import { api } from "@/api/axios.ts";
import { ApiOperationResult } from "@/types/common.types.ts";

export const apiComment = {
  addReaction: async function (commentId: number, emoji: string) {
    return api.post<ApiOperationResult>(`/api/v1/comments/${commentId}/reactions/`, { emoji });
  },
  deleteReaction: async function (commentId: number, emoji: string) {
    return api.delete<ApiOperationResult>(`/api/v1/comments/${commentId}/reactions/`, { emoji });
  },
};
